var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.974,
    height: 14.974,
    viewBox: "0 0 14.974 14.974",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5,5.995H3V16.476a1.5,1.5,0,0,0,1.5,1.5H14.979v-1.5H4.5ZM16.476,3H7.492a1.5,1.5,0,0,0-1.5,1.5v8.984a1.5,1.5,0,0,0,1.5,1.5h8.984a1.5,1.5,0,0,0,1.5-1.5V4.5A1.5,1.5,0,0,0,16.476,3Zm-.749,6.738H12.733v2.995h-1.5V9.738H8.241v-1.5h2.995V5.246h1.5V8.241h2.995Z",
    transform: "translate(-3 -3)",
    fill: "#FF5C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusOrange);
export default __webpack_public_path__ + "static/media/plus_orange.b4056a5db1f7160bb0f3e7a51f4c16db.svg";
export { ForwardRef as ReactComponent };